import "javascripts/removeExternalLink.js";
import "javascripts/has.polyfill.js";
import "javascripts/empty.polyfill.js";

require.context("../images", true);
require.context("../fonts", true);
